import { useEffect, useState } from "react"

export const useCheckoutLoading = (isSheetOpen: boolean) => {
  const [isLoading, setIsLoading] = useState(false)
  useEffect(() => {
    if (isSheetOpen && isLoading) setIsLoading(false)
  }, [isSheetOpen, isLoading])
  return [isLoading, setIsLoading] as const
}
